import { Button, Divider, Space, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useIntl } from "react-intl";

import { KioskAPI } from "@/api";
import Query from "@/models/query";
import AreYouSure from "@/ui/_common_/are-you-sure";

interface Props {
  kioskId: number;
}

export const CollectCashButton = observer<Props>(({ kioskId }) => {
  const intl = useIntl();

  const collectCashQuery = useMemo(() => {
    return new Query(() =>
      KioskAPI.notification({ id: kioskId, event: "money_to_cashbox" }),
    );
  }, [kioskId]);

  return (
    <>
      <Divider type="horizontal" />
      <Space direction="vertical" size={8}>
        <AreYouSure
          onYes={() => {
            void collectCashQuery.submit(undefined);
          }}
          disabled={collectCashQuery.isPending}
        >
          <Button type="primary" loading={collectCashQuery.isPending}>
            {intl.formatMessage({ defaultMessage: "Collect cash to cashbox" })}
          </Button>
        </AreYouSure>
        <Typography.Text>
          <strong>{intl.formatMessage({ defaultMessage: "Note" })}</strong>
          {": "}
          {intl.formatMessage({
            defaultMessage: "feature is only available with NVx",
          })}
        </Typography.Text>
      </Space>
    </>
  );
});
